import { render } from "./annualsub.vue?vue&type=template&id=1ed958a0"
import script from "./annualsub.vue?vue&type=script&lang=js"
export * from "./annualsub.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__